import styled from "@emotion/styled";
import { Modal } from "@mui/material";

export const TruckModalWrapper = styled(Modal)(({ theme }) => ({
	display: "flex",
	justifyContent: "center",
	alignItems: "center",
	padding: "0 20px",
	form: {
		backgroundColor: theme.project.colors.backgroundColors.main,
		boxShadow: `
            0px 11px 15px -7px #00000033,
            0px 24px 38px 3px #00000024,
            0px 9px 46px 8px #0000001F
        `,
		maxWidth: 600,
		width: "100%",
		color: theme.project.colors.fontColors.main,
		boxSizing: "border-box",
		borderRadius: "4px",
		h6: {
			margin: 0
		},
		"> div: first-of-type": {
			padding: "16px 24px",
			display: "flex",
			alignItems: "center",
			justifyContent: "space-between",
			svg: {
				color: theme.project.colors.fontColors.secondary,
				cursor: "pointer"
			}
		}
	}
}));

export const TruckOrderError = styled.div(({ theme }) => ({
	...theme.project.typography.alert.alertTitle,
	display: "flex",
	color: theme.project.colors.semanticColors.error,
	alignItems: "center",
	gap: 8
}));
